(function() {
  'use strict';

    angular.module('app.ui')
        .controller('DataTableCtrl', DataTableCtrl)
    ;

    /* @ngInject */
    function DataTableCtrl(DataFactory, $scope) {
        var vm = this;
		// DataFactory.getTableData(vm.tableDataKey).then(function(data){
		// 	vm.tableData = data;
		// });
    }

})();